import React, { useState } from "react";
import { db } from "../../base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const ListProduitsClients = ({ json }) => {
  const [url, setUrl] = useState(json.url);
  const [showDelete, setShowDelete] = useState("inactive");
  const collection = "json";

  const deletePdf = () => {
    db.collection(collection).doc(json.id).delete();
  };

  const handleShowDelete = () => {
    if (showDelete === "inactive") {
      setShowDelete("active");
    } else {
      setShowDelete("inactive");
    }
  };

  return (
    <li className="affiche-pdf">
      <a href={url} target="_blank" rel="noreferrer">{json.name}</a>
      <button className="trash" onClick={handleShowDelete}>
        <FontAwesomeIcon icon={faTrash} />
      </button>
      <div id="show-delete" className={showDelete}>
        <div className="title-buttons">
          <h2>Êtes-vous sûr de vouloir supprimer le fichier PDF {json.id}</h2>
          <button className="yes" onClick={deletePdf}>
            Oui
          </button>
          <button className="no" onClick={handleShowDelete}>
            Non
          </button>
        </div>
      </div>
    </li>
  );
};

export default ListProduitsClients;
